export { default } from './CameraDetallada';
